import { HFormat, HLink } from "@macashipo/mlib"
import HW from "./W"
//year-month-day
export const isStringDate = str => {
  if (
    /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z?/.test(str) ||
    /\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}/.test(str) ||
    /\d{4}-\d{2}-\d{2}/.test(str)
  ) {
    var d = new Date(str)
    return d.toString() !== "Invalid Date"
  }
  return false
}

export const isIsoDate = str => {
  if (
    /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z?/.test(str) ||
    /\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}/.test(str)
  ) {
    var d = new Date(str)
    return d.toString() !== "Invalid Date"
  }
  return false
}

export const isHexColorString = str => {
  if (str && typeof str == "string" && str.startsWith("#") && str.length == 7) {
    return true
  }
  return false
}

export const isIphone = () => {
  if (navigator.platform) {
    return /iPad|iPhone|iPod/.test(navigator.platform)
  }
  if (navigator.userAgentData && navigator.userAgentData.platform) {
    return /iPad|iPhone|iPod/.test(navigator.userAgentData.platform)
  }
  if (navigator.userAgent) {
    return /iPad|iPhone|iPod/.test(navigator.userAgent)
  }
  return false
}

export const isMobile = () => {
  return /Mobi|Android/i.test(navigator.userAgent)
}

export const isObject = function (value) {
  return Object(value) === value
}

export const isStringNotEmpty = function (value) {
  return typeof value === "string" && value.length > 0
}

export const isArray =
  Array.isArray ||
  function (value) {
    // check native isArray first
    return toString.call(value) === "[object Array]"
  }

export const isArguments = function (value) {
  // fallback check is for IE
  return (
    toString.call(value) === "[object Arguments]" ||
    (value != null && typeof value === "object" && "callee" in value)
  )
}
export const isEmpty = function (value) {
  if (isObject(value)) {
    var length = Object.getOwnPropertyNames(value).length
    if (
      length === 0 ||
      (length === 1 && isArray(value)) ||
      (length === 2 && isArguments(value))
    ) {
      return true
    }
    return false
  }
  return value === ""
}

export const getDateWithString = str => {
  var _date = new Date(str)
  return _date
}

//12:05, 01:10
export const isStringHourMinute = str => {
  if (/\d{1,2}:\d{1,2}/.test(str)) {
    var arr = str.split(":")
    if (Number(arr[0]) < 24 && Number(arr[1]) < 60) {
      return true
    }
  }
  return false
}

export const getDateWithHourMinute = str => {
  var _date = new Date()
  if (/\d{1,2}:\d{1,2}/.test(str)) {
    var arr = str.split(":")
    if (Number(arr[0]) < 24 && Number(arr[1]) < 60) {
      _date.setHours(Number(arr[0]))
      _date.setMinutes(Number(arr[1]))
    }
  }
  return _date
}

export const getStringHourMinuteFromDate = date => {
  let _str = ""
  if (date) {
    _str = `${padString(2, String(date.getHours()), "0")}:${padString(
      2,
      String(date.getMinutes()),
      "0"
    )}`
  }
  return _str
}

export const getStringDateFromDate = date => {
  let _str = ""
  if (date) {
    _str = HFormat.format(date.getTime(), {
      type: "date",
      format: "YYYY-MM-DD",
    })
  }
  return _str
}

export const padString = (width, string, padding) => {
  return width <= string.length
    ? string
    : padString(width, padding + string, padding)
}

export const checkPushArrayInObjIfNotExist = (obj, key, value) => {
  if (obj) {
    if (obj[key] == null) {
      obj[key] = []
    }
    if (obj[key] && obj[key].indexOf(value) == -1) {
      obj[key].push(value)
    }
  }
}

export const downloadFile = (fileUrl = "", name) => {
  //Set the File URL.
  var url = fileUrl
  var fileName = name || url.split("/").pop()
  //Create XMLHTTP Request.
  var req = new XMLHttpRequest()
  req.open("GET", url, true)
  req.responseType = "blob"
  req.onload = function () {
    //Convert the Byte Data to BLOB object.
    var blob = new Blob([req.response], { type: "application/octetstream" })
    //Check the Browser type and download the File.
    var isIE = false || !!document.documentMode
    if (isIE) {
      window.navigator.msSaveBlob(blob, fileName)
    } else {
      var url = window.URL || window.webkitURL
      var link = url.createObjectURL(blob)
      var a = document.createElement("a")
      a.setAttribute("download", fileName)
      a.setAttribute("href", link)
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  }
  req.send()
}

export const removeObjectFromArrayByFieldValue = (
  arr = [],
  fieldName,
  fieldValue
) => {
  if (arr && arr.length > 0 && fieldName) {
    for (var i = 0; i < arr.length; i++) {
      var obj = arr[i]
      if (obj[fieldName] == fieldValue) {
        arr.splice(i, 1)
        i--
      }
    }
    return arr
  }
  return []
}

export const getUUID = () => {
  return Math.random().toString(36).slice(2, 7)
}
export const getUUID8 = () => {
  return Math.random().toString(36).slice(2, 10)
}

export const parseJwt = token => {
  var base64Url = token.split(".")[1]
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/")
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join("")
  )

  return JSON.parse(jsonPayload)
}

export const mergeDeepObjects = (obj1, obj2) => {
  const merged = { ...obj1 }

  for (const key in obj2) {
    if (obj2.hasOwnProperty(key)) {
      if (
        typeof obj2[key] === "object" &&
        !Array.isArray(obj2[key]) &&
        obj1.hasOwnProperty(key) &&
        typeof obj1[key] === "object"
      ) {
        merged[key] = mergeDeepObjects(obj1[key], obj2[key])
      } else {
        merged[key] = obj2[key]
      }
    }
  }

  return merged
}

export const isHasDoubleByte = str => {
  for (var i = 0, n = str.length; i < n; i++) {
    if (str.charCodeAt(i) > 255) {
      return true
    }
  }
  return false
}

export const addClassBody = cls => {
  if (cls) {
    window.document.body.classList.add(cls)
  }
}

export const removeClassBody = cls => {
  if (cls) {
    window.document.body.classList.remove(cls)
  }
}

export const addScript = url => {
  var script = document.createElement("script")
  script.type = "application/javascript"
  script.src = url
  document.head.appendChild(script)
}
//addScript('https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js');

export const getParentNodeHasClass = (node, classParent, deep = 5) => {
  if (node && node.parentNode) {
    if (node.parentNode.classList.contains(classParent)) {
      return node.parentNode
    } else if (deep > 0) {
      return getParentNodeHasClass(node.parentNode, classParent, deep - 1)
    }
  }
  return null
}

export const getQueryFromData = (query, data) => {
  let _queryMore = query || {}
  let _query = {}
  let _obj = Object.keys(_queryMore)
  if (_obj && _obj.length > 0) {
    for (let i of _obj) {
      let _value = _queryMore[i]
      if (data.hasOwnProperty(_value) == true) {
        if (data[_value] != null) {
          _query[i] = data[_value]
        }
      } else {
        _query[i] = _queryMore[i]
      }
    }
  }
  return _query
}

export const addDataToObj = (sourceObj, addedObj) => {
  if (sourceObj && addedObj) {
    let _keys = Object.keys(addedObj)
    for (let k of _keys) {
      if (Array.isArray(addedObj[k])) {
        sourceObj[k] = addedObj[k]
      } else if (typeof addedObj[k] == "object") {
        if (sourceObj[k] == null) {
          //kiem tra neu chua co source[k] thi khoi tao object rong
          sourceObj[k] = {}
        }
        addDataToObj(sourceObj[k], addedObj[k])
      } else {
        sourceObj[k] = addedObj[k]
      }
    }
  }
  return sourceObj
}

export const getScreenSizeByBreakpoints = (
  breakpoints = { mobile: 0, tablet: 768, desktop: 1024 }
) => {
  // console.log("getScreenSizeByBreakpoints:", breakpoints)
  if (breakpoints) {
    const sortedEntries = Object.entries(breakpoints).sort(
      ([, a], [, b]) => a - b
    )
    let result = sortedEntries[0][0] // default là loại đầu tiên
    for (const [key, minWidth] of sortedEntries) {
      if (window.innerWidth >= minWidth) {
        result = key
      } else {
        break
      }
    }
    return result
  }
}

export const evalInScope = (js, contextAsScope) => {
  try {
    // eslint-disable-next-line
    return new Function(`with (this) { return (${js}); }`).call(contextAsScope)
    // eslint-disable-next-line
    // return eval(js)
  } catch (error) {
    console.error("evalInScope:", js, contextAsScope, error)
  }
}

export const cloneObj = (obj = {}) => {
  try {
    return JSON.parse(JSON.stringify(obj))
  } catch (error) {
    console.warn("error:", error)
  }
  return null
}

export const isMobileModeLayout = () => {
  return window.innerWidth < 1200
}

// Hàm chuyển đổi ký tự ASCII thành chuỗi nhị phân
export const asciiToBinary = str => {
  return str
    .split("")
    .map(char => {
      return char.charCodeAt(0).toString(2).padStart(8, "0")
    })
    .join("")
}

export const unicodeToBinary = unicodeStr => {
  return unicodeStr
    .split("")
    .map(char => {
      return char.charCodeAt(0).toString(2).padStart(16, "0") // Chuyển từng ký tự Unicode thành 16 bit nhị phân
    })
    .join("")
}

// Hàm chuyển đổi chuỗi nhị phân thành ký tự Unicode
export const binaryToUnicode = binStr => {
  let unicodeStr = ""
  for (let i = 0; i < binStr.length; i += 16) {
    const binSegment = binStr.slice(i, i + 16)
    const unicodeChar = String.fromCharCode(parseInt(binSegment, 2))
    unicodeStr += unicodeChar
  }
  return unicodeStr
}

// Chuyển chuỗi nhị phân trở lại ký tự ASCII
export const binaryToAscii = binStr => {
  let asciiStr = ""
  for (let i = 0; i < binStr.length; i += 8) {
    const binSegment = binStr.slice(i, i + 8)
    const asciiChar = String.fromCharCode(parseInt(binSegment, 2))
    asciiStr += asciiChar
  }
  return asciiStr
}

export const getRandomItemFromArray = arr => {
  if (!Array.isArray(arr) || arr.length === 0) {
    return null // Return undefined for empty or invalid input
  }
  const randomIndex = Math.floor(Math.random() * arr.length)
  return arr[randomIndex]
}

// Hàm gom 1 chuỗi ASCII thành 1 chuỗi Unicode ngắn hơn
export const compressAsciiToUnicode = str => {
  const binaryStr = asciiToBinary(str)
  return binaryToUnicode(binaryStr)
}

export const decompressUnicodeToAscii = unicodeStr => {
  const binaryStr = unicodeToBinary(unicodeStr)
  return binaryToAscii(binaryStr)
}

export const changeLogoLink = (
  link,
  target = "_blank",
  { centerLogo } = {}
) => {
  console.log("changelogolink")
  let _imgLogo = document.querySelector(".app-header-left-logo img")
  if (_imgLogo && link) {
    _imgLogo.onclick = ev => {
      console.log("click logo")
      HLink.openUrl(link, target)
      ev.preventDefault()
      ev.stopPropagation()
    }
  }
  let _imgLogoMobile = document.querySelector(".app-header__logo .logo-src img")
  if (_imgLogoMobile && link) {
    _imgLogoMobile.onclick = ev => {
      console.log("click logo mobile")
      HLink.openUrl(link, target)
      ev.preventDefault()
      ev.stopPropagation()
    }
  }

  if (centerLogo) {
    if (_imgLogo && _imgLogo.style) {
      _imgLogo.style.position = "absolute"
      _imgLogo.style.left = "50%"
      _imgLogo.style.top = "8px"
      _imgLogo.style.transform = "translate(-50%, 0%)"
    }
    // if (_imgLogoMobile && _imgLogoMobile.style) {
    //   _imgLogoMobile.style.position = "absolute"
    //   _imgLogoMobile.style.left = "50%"
    //   _imgLogoMobile.style.top = "8px"
    //   _imgLogoMobile.style.transform = "translate(-50%, 0%)"
    // }
  }
}

var ChuSo = [
  " không",
  " một",
  " hai",
  " ba",
  " bốn",
  " năm",
  " sáu",
  " bảy",
  " tám",
  " chín",
]
var Tien = ["", " nghìn", " triệu", " tỷ", " nghìn tỷ", " triệu tỷ"]

//1. Hàm đọc số có ba chữ số;
function DocSo3ChuSo(baso) {
  var tram
  var chuc
  var donvi
  var KetQua = ""
  tram = parseInt(baso / 100)
  chuc = parseInt((baso % 100) / 10)
  donvi = baso % 10
  if (tram == 0 && chuc == 0 && donvi == 0) return ""
  if (tram != 0) {
    KetQua += ChuSo[tram] + " trăm"
    if (chuc == 0 && donvi != 0) KetQua += " linh"
  }
  if (chuc != 0 && chuc != 1) {
    KetQua += ChuSo[chuc] + " mươi"
    if (chuc == 0 && donvi != 0) KetQua = KetQua + " linh"
  }
  if (chuc == 1) KetQua += " mười"
  switch (donvi) {
    case 1:
      if (chuc != 0 && chuc != 1) {
        KetQua += " mốt"
      } else {
        KetQua += ChuSo[donvi]
      }
      break
    case 5:
      if (chuc == 0) {
        KetQua += ChuSo[donvi]
      } else {
        KetQua += " lăm"
      }
      break
    default:
      if (donvi != 0) {
        KetQua += ChuSo[donvi]
      }
      break
  }
  return KetQua
}
export const convertToVietnameseWords = (n = "") => {
  if (n == "") {
    return ""
  }
  var SoTien = n.replaceAll(",", "").replaceAll(".", "")
  var lan = 0
  var i = 0
  var so = 0
  var KetQua = ""
  var tmp = ""
  var ViTri = []
  if (SoTien < 0) return "Số tiền âm !"
  if (SoTien == 0) return "Không đồng !"
  if (SoTien > 0) {
    so = SoTien
  } else {
    so = -SoTien
  }
  if (SoTien > 8999999999999999) {
    //SoTien = 0;
    return "Số quá lớn!"
  }
  ViTri[5] = Math.floor(so / 1000000000000000)
  if (isNaN(ViTri[5])) ViTri[5] = "0"
  so = so - parseFloat(ViTri[5].toString()) * 1000000000000000
  ViTri[4] = Math.floor(so / 1000000000000)
  if (isNaN(ViTri[4])) ViTri[4] = "0"
  so = so - parseFloat(ViTri[4].toString()) * 1000000000000
  ViTri[3] = Math.floor(so / 1000000000)
  if (isNaN(ViTri[3])) ViTri[3] = "0"
  so = so - parseFloat(ViTri[3].toString()) * 1000000000
  ViTri[2] = parseInt(so / 1000000)
  if (isNaN(ViTri[2])) ViTri[2] = "0"
  ViTri[1] = parseInt((so % 1000000) / 1000)
  if (isNaN(ViTri[1])) ViTri[1] = "0"
  ViTri[0] = parseInt(so % 1000)
  if (isNaN(ViTri[0])) ViTri[0] = "0"
  if (ViTri[5] > 0) {
    lan = 5
  } else if (ViTri[4] > 0) {
    lan = 4
  } else if (ViTri[3] > 0) {
    lan = 3
  } else if (ViTri[2] > 0) {
    lan = 2
  } else if (ViTri[1] > 0) {
    lan = 1
  } else {
    lan = 0
  }
  for (i = lan; i >= 0; i--) {
    tmp = DocSo3ChuSo(ViTri[i])
    KetQua += tmp
    if (ViTri[i] > 0) KetQua += Tien[i]
    if (i > 0 && tmp.length > 0) KetQua += ","
  }
  if (KetQua.substring(KetQua.length - 1) == ",") {
    KetQua = KetQua.substring(0, KetQua.length - 1)
  }
  KetQua = KetQua.substring(1, 2).toUpperCase() + KetQua.substring(2) + " đồng"
  return KetQua
}
